export function openSessionSocket({ token, sessionId, clientToken, onEvent }) {
  const socket = new WebSocket(process.env.VUE_APP_WS_URL || 'ws://localhost:3100/ws');
  socket.addEventListener('open', () => {
    socket.send(JSON.stringify({ event: 'auth', data: clientToken ? { clientToken } : { token, sessionId } }));
  });
  socket.addEventListener('message', (message) => {
    const payload = JSON.parse(message.data || '{}');
    if (onEvent) onEvent(payload.event, payload.data);
  });
  return socket;
}
